import React from "react";
import axios from "axios";
import { GlobalError } from "../../../components/errors/GlobalError";

export const GetRemoteAuthenticationToken =
  (
    setLoading: React.Dispatch<React.SetStateAction<boolean>>,
    setToken: React.Dispatch<React.SetStateAction<string>>
  ) =>
  async () => {
    setLoading(true);
    const BASE_URL = process.env.REACT_APP_BASE_URL;

    try {
      const remoteAuthenticationTokenResponse = await axios.get(
        `${BASE_URL}/api/users/remoteAuthToken`
      );
      console.log("this is the remoteLoginTokenUrlResponse", remoteAuthenticationTokenResponse);
      if (remoteAuthenticationTokenResponse.status === 200) {
        setLoading(false);
        setToken(remoteAuthenticationTokenResponse.data.token);
      }
    } catch (error: any) {
      GlobalError(error);
      setLoading(false);
    }
  };
